import { useContext } from 'react'
import { RequesterQuestionnaireContext } from '../Requester'

const useRequesterContext = () => {
  return useContext(RequesterQuestionnaireContext)
}

export default useRequesterContext
